// extracted by mini-css-extract-plugin
export default {"wrapper":"u8M13aUO--styles_wrapper__e1vZ9","shimmer":"u8M13aUO--styles_shimmer__yjk7r"};